/**
 * Shared filter search helpers for column, attribute, and group pickers.
 *
 * Centralising the match predicate here guarantees that all filter surfaces
 * (Filter population modal, Add a segment filter modal, …) apply the exact
 * same logic and never drift.
 *
 * cache scope: one-shot per keystroke, not cached
 */

/**
 * Returns true when `query` appears as a case-insensitive substring in
 * **any** of the supplied candidates. Null/undefined candidates are silently
 * skipped so callers can pass optional fields without extra guards.
 *
 * Both `query` and candidates are lowercased internally — callers do not
 * need to pre-lowercase the query.
 */
export function includesQuery(
  query: string,
  ...candidates: Array<string | null | undefined>
): boolean {
  const q = query.toLowerCase()
  for (const c of candidates) {
    if (c && c.toLowerCase().includes(q)) return true
  }
  return false
}

/**
 * Returns true when `code` should be surfaced as a secondary muted label
 * next to the human-readable display label.
 *
 * Suppressed when the code is identical to the label (case-insensitive) or
 * when the code itself looks like a long question sentence (contains spaces),
 * since those add no discoverability value.
 */
export function isDisplayableCode(code: string, label: string): boolean {
  if (!code) return false
  if (code.toLowerCase() === label.toLowerCase()) return false
  if (code.includes(' ')) return false
  return true
}
